import { render, staticRenderFns } from "./EgresoCreate.vue?vue&type=template&id=3cb028a1&scoped=true"
import script from "./EgresoCreate.vue?vue&type=script&lang=js"
export * from "./EgresoCreate.vue?vue&type=script&lang=js"
import style0 from "./EgresoCreate.vue?vue&type=style&index=0&id=3cb028a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb028a1",
  null
  
)

export default component.exports